define(function (require, exports, module) {
    window.jQuery = require('jquery');
    require('lib/can.custom');
    module.exports = window.can;
});